module.exports = __webpack_public_path__ + "images/avatars/female/13.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/13.png
// module id = aRaM
// module chunks = 118